/**
 * The single query client.
 *
 * It lives in its own module rather than in App.tsx because the auth layer
 * has to empty it when the signed-in company changes, and App.tsx already
 * imports the auth layer -- importing back the other way would be a cycle.
 */
import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Accounting data must be current; do not serve stale figures.
      staleTime: 0,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
})
